module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAABH0lEQVQokWXSvyvFYRTH8df93juIBfmRgUWijDf+CRuxGLDchYUkSkxmsriJhYjBcg2kyEai7AZKhmtBKQNicHDjU6fn6fm8z3l6nnNSuVxOqALD6EEDUihiC3k8QxJwK85RhT40oTGSa8JrgwwqsYsRHKAMXVHoEJM4QgGdCcaxHXAtztAbcRY3HAQznoSRj4qTWMNgxDqmwsujL4mqd3FYjRu/uo53CaY2gwfU4R4rWMVLQHMYin09iulsNluNDhzjNn5kAO2YxkkkTOAygwVcYANXOI0oVQv6kU3wiFFsotx/lYc3hqfvxhWwj2WkS+BUnO0F89NpmIl1KUBYjHX2G8qUJHz4+vsdzOPV14h0h+fvDfDmd5aaY/9eCnwC8nQ/4plW2RoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/sh.png
// module id = JVbj
// module chunks = 1